import {
  CookieConsent,
  getCookieConsent,
  setCookieConsent,
} from '../../lib/localStorage/signUp/cookieConsent';
import {isCookieCategoriesChanged} from './lib/isCookieCategoriesChanged';

type PendingDecision = {
  promise: Promise<CookieConsent>;
  resolve: (value: CookieConsent) => void;
};

class CookieConsentService {
  private decision: CookieConsent | null = null;
  private pendingDecision: PendingDecision | null = null;

  constructor() {
    const cookieConsent = getCookieConsent();
    if (cookieConsent) {
      this.setDecision(cookieConsent);
    }
  }

  public readFromStorage(): CookieConsent | null {
    return getCookieConsent();
  }

  public saveCategoriesDecision(
    consentCategories: CookieConsent['categories']
  ) {
    const storedConsent = getCookieConsent();
    if (
      !isCookieCategoriesChanged(storedConsent?.categories, consentCategories)
    ) {
      return false;
    }

    const now = Date.now();
    const cookieConsent: CookieConsent = {
      // keep acceptAt from previous state
      acceptAt: now,
      ...storedConsent,
      changedAt: now,
      categories: consentCategories,
    };
    setCookieConsent(cookieConsent);
    this.setDecision(cookieConsent);

    return true;
  }

  public waitForDecision(): Promise<CookieConsent> {
    if (this.decision) {
      return Promise.resolve(this.decision);
    }

    if (this.pendingDecision) {
      return this.pendingDecision.promise;
    }

    this.pendingDecision = this.createPendingDecision();

    return this.pendingDecision.promise;
  }

  private createPendingDecision(): PendingDecision {
    let resolve!: (value: CookieConsent) => void;
    const promise = new Promise<CookieConsent>((res) => {
      resolve = res;
    });

    return {promise, resolve};
  }

  private setDecision(consent: CookieConsent): void {
    this.decision = consent;
    this.pendingDecision?.resolve(consent);
    this.pendingDecision = null;
  }
}

export const cookieConsentService = new CookieConsentService();
